{
    "Title": "Gerir filas",
    "ManageQueuesDescriptionTitle": "Descrição",
    "ManageQueuesCQConfigurationsTitle": "Configurações CQ",
    "ManageQueuesResourceAccountsTitle": "Contas de Recursos",
    "ManageQueuesMonitoringStatusTitle": "Estado de monitorização",
    "ManageQueueFiltersTitle": "Filtros",
    "ManageQueueCallMonitoringHistoric": "Histórico",
    "ManageQueueCallMonitoringRealTime": "Em tempo real",
    "ManageQueueCallMonitoringRealTimeForced": "Tempo real (forçado)",
    "ManageQueueCallMonitoringUnknown": "Desconhecido",
    "ManageQueueCallCQConfigurationCompatible": "Compatível",
    "ManageQueueCallCQConfigurationIncompatible": "Incompatível",
    "ManageQueuesQueueFilterAll": "Todas as filas",
    "ManageQueuesFilterCompatible": "Filas Compatíveis",
    "ManageQueuesFilterIncompatible": "Filas incompatíveis",
    "ManageQueue_DisableEnableRealtime_Confirm": "Confirmar",
    "ManageQueue_DisableEnableRealtime_Cancel": "Cancelar",
    "ManageQueue_MonitorAllMessage": "Tem certeza de que deseja ativar a monitorização em tempo real para todas as filas?",
    "ManageQueue_UnmonitorAllMessage": "Tem certeza de que deseja desativar a monitorização em tempo real para todas as filas?",
    "ManageQueue_Loading_Monitoring_All": "A ativar a monitorização em tempo real para todas as filas",
    "ManageQueue_Loading_Unmonitoring_All": "Desabilitando a monitorização em tempo real para todas as filas",
    "ManageQueue_Pending_Queue_Disabling": "Desabilitando a monitorização...",
    "ManageQueue_Pending_Queue_Enabling": "A ativar a monitorização...",
    "ManageQueue_Disable_RT_Popper": "Desabilitar monitorização em tempo real em todas as filas",
    "ManageQueue_Enable_RT_Popper": "Ativar monitorização em tempo real em todas as filas",
    "ManageQueues_Not_Found_Error": "Nenhuma fila correspondente a essa pesquisa foi encontrada",
    "NAME": "ManageQueues",
    "ManageQueues_Linkage_Title": "Contas de recursos vinculados \/ Aplicações de voz",
    "ManageQueues_Linkage_Help": "Clique em Ajuda para descobrir como revincular contas de recursos",
    "ManageQueues_Linkage_Types_CallQueue": "A conta de recurso '**{}**' é usada para tratamento de exceção '**{}**' na Fila de Espera '**{}**'.",
    "ManageQueues_Linkage_Types_AutoAttendant": "A conta de recurso '**{}**' é usada para a opção '**{}**' de '**{}**' no IVR '**{}**'.",
    "ManageQueues_Linkage_Types_Policy": "A conta de recurso '**{}**' é usada dentro da política '**{}**' do tipo '**{}**'.",
    "ManageQueues_Linkage_CallQueue_Exceptions_overflow": "Sobrecarga",
    "ManageQueues_Linkage_CallQueue_Exceptions_timeout": "Tempo esgotado",
    "ManageQueues_Linkage_CallQueue_Exceptions_noagent": "Nenhum agente",
    "ManageQueues_Linkage_CallQueue_Exceptions_obo": "Em nome de",
    "ManageQueues_Linkage_AutoAttendant_Menu_Options_businesshours": "Horário de expediente",
    "ManageQueues_Linkage_AutoAttendant_Menu_Options_afterhours": "Horário fora de horas",
    "ManageQueues_Linkage_AutoAttendant_Menu_Options_holiday": "Período de férias",
    "ManageQueues_Linkage_Policy_Types_teamssharedcallingroutingpolicy": "Política de roteamento de chamadas compartilhadas",
    "ManageQueues_Linkage_Policy_Types_teamsunassignednumbertreatment ": "Anúncio de Número Não Atribuído",
    "ManageQueues_Linkage_Policy_Types_callinglineidentity": "Identidade da linha de chamada",
    "ManageQueues_Linkage_Options_automatic": "Redirecionar",
    "ManageQueues_Linkage_Options_pound": "Cardinal",
    "ManageQueues_Linkage_Options_star": "Asterisco",
    "ManageQueues_Linkage_NoInfo": "Não existem referências de contas de recursos para esta fila.",
    "ManageQueues_Incompatibility_Popup_Title": "Definições incompatíveis",
    "ManageQueues_ExchangePermission_Error": "Permissão de administrador\/Exchange não encontrada para o utilizador de autenticação TelSys. Não é possível criar mensagens de voz compartilhadas."
}